import { useContext, useEffect, useState } from "react";
import { UseFormReturn } from "react-hook-form";
import { Typography, Select, Input, Table, Form, Tag, Radio } from "antd";
import { CurrencyInput } from "../../../../Components/Shared/CurrencyInput";
import { InnovationActivityFinepModel } from "../../../../Models/InnovationActivityFINEPModel";
import TabsHeader from "../../../../Components/Shared/TabsHeader";
import Loader from "../../../../Components/Shared/Loader";
import useLoading from "../../../../Hooks/useLoading";
import { governmentSupportEnum } from "../../../../Static/GovernmentSupportEnum";
import { PostInnovationActivityFinepAPI, PutInnovationActivityFinepAPI } from "../../../../API/InnovationActivityFinepAPI";
import { IResponseProps } from "../../../../Interfaces/IResponseProps";
import { toast } from "react-toastify";
import { convertCurrencyToFloat } from "../../../../Utils/convertCurrencyToFloat";
import { TechnologicalFeaturesFinepContext } from "../../../../Contexts/TechnologicalFeaturesFinepContext";
import './styles.css';

const { Title, Text } = Typography;
const { Option } = Select;
const { TextArea } = Input;
interface ActivitiesInnovationTabProps {
    innovationActivityForm: UseFormReturn<InnovationActivityFinepModel, any>,
    getFilledFourthTabCount: (dataResp: InnovationActivityFinepModel) => number,
    calculatePercentage: (isValidated: boolean, tabName: string, qtdFilled: number) => void,
    setCanValidateFourthTab: React.Dispatch<React.SetStateAction<boolean>>,
    canValidateFourthTab: boolean
}

export const ActivitiesInnovationTab = (props: ActivitiesInnovationTabProps) => {
    const { watch, register, handleSubmit, setValue, getValues, formState } = props.innovationActivityForm;
    const { isDirty, dirtyFields } = formState;
    const { loading, toggleLoading } = useLoading();
    const [hasValidated, setHasValidated] = useState<boolean>(false);
    const [governmentSupport, setGovernmentSupport] = useState<string[]>([]);
    const innovationActivityFields = 15;
    const watchIsValid = watch("isValid");
    const watchGovernment = watch('governmentSupportPrograms');
    const { handleFillTab } = useContext(TechnologicalFeaturesFinepContext);

    const PostInnovationActivityFinep = async (data: InnovationActivityFinepModel) => {
        try {
            toggleLoading(true);
            await PostInnovationActivityFinepAPI(data).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    var dataResp = resp.data;
                    var filled = props.getFilledFourthTabCount(dataResp);
                    if (filled == innovationActivityFields) {
                        props.setCanValidateFourthTab(true);
                    } else {
                        props.setCanValidateFourthTab(false);
                    }
                    setValue('id', dataResp.id);
                    handleFillTab(3);
                    props.calculatePercentage(data.isValid, 'innovationActivity', filled);
                }
            });
        } catch (error: any) {
            toast.error(error);
        } finally {
            toggleLoading(false);
        }
    }

    const PutInnovationActivityFinep = async (data: InnovationActivityFinepModel) => {
        try {
            toggleLoading(true);
            await PutInnovationActivityFinepAPI(data).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    var dataResp = resp.data;
                    var filled = props.getFilledFourthTabCount(dataResp);
                    if (filled == innovationActivityFields) {
                        props.setCanValidateFourthTab(true);
                    } else {
                        props.setCanValidateFourthTab(false);
                    }
                    handleFillTab(3);
                    props.calculatePercentage(data.isValid, 'innovationActivity', filled);
                }
            });
        } catch (error: any) {
            toast.error(error);
        } finally {
            toggleLoading(false);
        }
    }

    const EditFields = (data: InnovationActivityFinepModel) => {
        if (dirtyFields.totalValueOfICTContracts) {
            let value = 0;
            if (data.totalValueOfICTContracts.toString().includes("R$")) {
                value = convertCurrencyToFloat(data.totalValueOfICTContracts.toString());
            } else {
                value = parseFloat(data.totalValueOfICTContracts.toString())
            }
            data.totalValueOfICTContracts = value;
            setValue('totalValueOfICTContracts', value);
        }
        if (dirtyFields.totalValueOfCompanyPartnerships) {
            let value = 0;
            if (data.totalValueOfCompanyPartnerships.toString().includes("R$")) {
                value = convertCurrencyToFloat(data.totalValueOfCompanyPartnerships.toString());
            } else {
                value = parseFloat(data.totalValueOfCompanyPartnerships.toString())
            }
            data.totalValueOfCompanyPartnerships = value;
            setValue('totalValueOfCompanyPartnerships', value);
        }
        if (dirtyFields.internalRnDExpenditures) {
            let value = 0;
            if (data.internalRnDExpenditures.toString().includes("R$")) {
                value = convertCurrencyToFloat(data.internalRnDExpenditures.toString());
            } else {
                value = parseFloat(data.internalRnDExpenditures.toString())
            }
            data.internalRnDExpenditures = value;
            setValue('internalRnDExpenditures', value);
        }
        if (dirtyFields.externalRnDExpenditures) {
            let value = 0;
            if (data.externalRnDExpenditures.toString().includes("R$")) {
                value = convertCurrencyToFloat(data.externalRnDExpenditures.toString());
            } else {
                value = parseFloat(data.externalRnDExpenditures.toString());
            }
            data.externalRnDExpenditures = value;
            setValue('externalRnDExpenditures', value);
        }
        if (dirtyFields.machineryAndEquipmentExpenditures) {
            let value = 0;
            if (data.machineryAndEquipmentExpenditures.toString().includes("R$")) {
                value = convertCurrencyToFloat(data.machineryAndEquipmentExpenditures.toString());
            } else {
                value = parseFloat(data.machineryAndEquipmentExpenditures.toString());
            }
            data.machineryAndEquipmentExpenditures = value;
            setValue('machineryAndEquipmentExpenditures', value);
        }
        if (dirtyFields.totalInnovativeActivityExpenditures) {
            let value = 0;
            if (data.totalInnovativeActivityExpenditures.toString().includes("R$")) {
                value = convertCurrencyToFloat(data.totalInnovativeActivityExpenditures.toString());
            } else {
                value = parseFloat(data.totalInnovativeActivityExpenditures.toString())
            }
            data.totalInnovativeActivityExpenditures = value;
            setValue('totalInnovativeActivityExpenditures', value);
        }
        let value1 = JSON.parse(data.hasDepToPndLocal.toString());
        data.hasDepToPndLocal = value1;
        setValue('hasDepToPndLocal', value1.toString());
        let value2 = JSON.parse(data.hasDepToPndGlobal.toString());
        data.hasDepToPndGlobal = value2;
        setValue('hasDepToPndGlobal', value2.toString());
        return data;
    }

    const submitActivitiesInnovationForm = (data: InnovationActivityFinepModel) => {
        if (isDirty || hasValidated != data.isValid) {
            data.governmentSupportPrograms = governmentSupport.join(",");
            if (data.pndActivityLastYears?.toString() == "") {
                data.pndActivityLastYears = undefined;
            }
            var newData = EditFields(data);
            if (data.governmentSupportPrograms.includes("others") && data.others == "") {
                return;
            }
            if ((data.hasDepToPndLocal == true && data.activityPndLocal == "") || (data.hasDepToPndGlobal == true && data.activityPndGlobal == "")) {
                return;
            }
            newData.isValid = hasValidated;
            setValue('isValid', hasValidated);
            if (newData.id != "") {
                PutInnovationActivityFinep(newData);
            } else {
                PostInnovationActivityFinep(newData);
            }
        }
    };

    const handleChange = (value: string[]) => {
        setGovernmentSupport(value);
    };

    const updateGovernment = () => {
        setGovernmentSupport(getValues("governmentSupportPrograms") != "" ? getValues("governmentSupportPrograms").split(",") : []);
    }

    const updateHasValidated = () => {
        setHasValidated(props.canValidateFourthTab == true ? JSON.parse(getValues("isValid").toString()) : false);
    }

    useEffect(() => {
        updateGovernment();
    }, [watchGovernment]);

    useEffect(() => {
        if (hasValidated.toString() != getValues("isValid").toString()) {
            submitActivitiesInnovationForm(getValues());
        }
    }, [hasValidated]);

    useEffect(() => {
        updateHasValidated();
    }, [watchIsValid, props.canValidateFourthTab]);

    const qualificationColumns = [
        {
            title: <span className="color-blue">Nível de Qualificação</span>,
            dataIndex: 'qualification',
            key: 'qualification',
        },
        {
            title: <span className="color-blue">Total de Pessoas</span>,
            dataIndex: 'total',
            key: 'total',
            render: (text: string, record: any) => (
                <Input
                    type="number"
                    disabled={hasValidated}
                    suffix="Pessoas"
                    {...register(record.field as any, { onBlur: handleSubmit(submitActivitiesInnovationForm), valueAsNumber: true })}
                />
            ),
        },
    ];

    const dedicationColumns = [
        {
            title: <span className="color-blue">Nível de Dedicação às atividades de P&D</span>,
            dataIndex: 'dedication',
            key: 'dedication',
        },
        {
            title: <span className="color-blue">Total de Pessoas</span>,
            dataIndex: 'total',
            key: 'total',
            render: (text: string, record: any) => (
                <Input
                    type="number"
                    suffix="Pessoas"
                    disabled={hasValidated}
                    {...register(record.field as any, { onBlur: handleSubmit(submitActivitiesInnovationForm), valueAsNumber: true })}
                />
            ),
        },
    ];

    const qualificationData = [
        { qualification: 'Pesquisadores - Doutores', field: 'qtResearchersDoctors' },
        { qualification: 'Pesquisadores - Mestres', field: 'qtResearchersMasters' },
        { qualification: 'Pesquisadores - Graduados', field: 'qtResearchersGraduates' },
        { qualification: 'Pesquisadores - Médio e Fundamental', field: 'qtResearchersBasic' },
        { qualification: 'Técnicos - Graduados', field: 'qtTechniciansGraduates' },
        { qualification: 'Técnicos - Médio e Fundamental', field: 'qtTechniciansBasic' },
        { qualification: 'Auxiliares - Outros', field: 'qtAssistantOther' },
    ];

    const dedicationData = [
        { dedication: 'Dedicação Exclusiva', field: 'qtDedicationExclusive' },
        { dedication: 'Dedicação Parcial', field: 'qtDedicationPartial' },
    ];

    return (
        <form onSubmit={handleSubmit(submitActivitiesInnovationForm)}>
            {loading && <Loader />}
            <div className="p-4">
                <TabsHeader
                    canValidate={props.canValidateFourthTab}
                    setValueSelected={setHasValidated}
                    valueSelected={hasValidated}
                    registerId={getValues("registerId")}
                    cardName=""
                    tabName=""
                />
                <Title level={4} >
                    <strong className="color-blue">Infraestrutura P&D</strong>
                </Title>
                <div className="mt-4" style={{ display: 'flex', flexDirection: 'column' }}>
                    <p>As atividades de P&D realizadas nos últimos 3 anos foram:</p>
                    <Select
                        className="w-100"
                        disabled={hasValidated}
                        value={getValues('pndActivityLastYears')?.toString() ?? ""}
                        onChange={(value) => {
                            setValue('pndActivityLastYears', parseInt(value));
                            handleSubmit(submitActivitiesInnovationForm)();
                        }}
                        style={{ width: 200 }}
                    >
                        <Option value="0">Inexistentes</Option>
                        <Option value="1">Ocasionais</Option>
                        <Option value="2">Contínuas</Option>
                    </Select>
                </div>
                <div className="mt-4" style={{ display: 'flex', flexDirection: 'column' }}>
                    <p>A empresa possui departamento, ou unidade formal, para execução das atividades internas de P&D no Brasil?</p>
                    <Select
                        className="w-25"
                        disabled={hasValidated}
                        value={getValues('hasDepToPndLocal')?.toString()}
                        onChange={(value) => {
                            setValue('hasDepToPndLocal', value === 'true');
                            handleSubmit(submitActivitiesInnovationForm)();
                        }}
                        style={{ width: 200 }}
                    >
                        <Option value="true">Sim</Option>
                        <Option value="false">Não</Option>
                    </Select>
                </div>
                {getValues('hasDepToPndLocal') && (
                    <div className="mt-4" style={{ display: 'flex', flexDirection: 'column' }}>
                        <p>Indique a localização do(s) departamento(s), ou da(s) unidade(s) formal(is), onde se concentram as atividades de P&D da empresa:</p>
                        <TextArea
                            disabled={hasValidated}
                            placeholder="Descreva aqui..."
                            {...register('activityPndLocal', { onBlur: handleSubmit(submitActivitiesInnovationForm) })}
                            rows={4}
                        />
                    </div>
                )}
                <div className="mt-4" style={{ display: 'flex', flexDirection: 'column' }}>
                    <p>A empresa possui departamento, ou unidade formal, para execução das atividades internas de P&D localizado no exterior?</p>
                    <Select
                        className="w-25"
                        disabled={hasValidated}
                        value={getValues('hasDepToPndGlobal')?.toString()}
                        onChange={(value) => {
                            setValue('hasDepToPndGlobal', value === 'true');
                            handleSubmit(submitActivitiesInnovationForm)();
                        }}
                        style={{ width: 200 }}
                    >
                        <Option value="true">Sim</Option>
                        <Option value="false">Não</Option>
                    </Select>
                </div>
                {getValues('hasDepToPndGlobal')?.toString() == "true" && (
                    <div className="mt-4" style={{ display: 'flex', flexDirection: 'column' }}>
                        <p>Descreva a infraestrutura própria utilizada para as atividades inovativas:</p>
                        <Input.TextArea
                            disabled={hasValidated}
                            placeholder="Descreva aqui..."
                            {...register('activityPndGlobal', { onBlur: handleSubmit(submitActivitiesInnovationForm) })}
                            rows={4}
                        />
                    </div>
                )}
                <Title level={4} className="mt-4">
                    <strong style={{ color: '#000085' }}>Pessoal Ocupado em Atividades de P&D</strong>
                </Title>
                <p className="mt-4 d-block w-75">Informe o número de pessoas do quadro da empresa ocupadas nas atividades de P&D no último ano, segundo o nível de qualificação e o tempo de dedicação e estas atividades:</p>
                <div className="d-flex mt-4 w-100">
                    <div className="w-100 me-4">
                        <Table
                            columns={qualificationColumns}
                            dataSource={qualificationData}
                            pagination={false}
                            bordered={false}
                            className="no-border-table"
                        />
                    </div>
                    <div className="w-100">
                        <Table
                            columns={dedicationColumns}
                            dataSource={dedicationData}
                            pagination={false}
                            bordered={false}
                            className="no-border-table"
                        />
                    </div>
                </div>
                <Title level={4} className="mt-4">
                    <strong style={{ color: '#000085' }}>Parcerias em Atividades Inovativas</strong>
                </Title>
                <Form.Item label="Quantos contratos de parceria com ICTs para auxílio às atividades inovativas da empresa estavam vigentes no último ano?" className="mt-4">
                    <Input
                        type="number"
                        style={{ width: 200 }}
                        disabled={hasValidated}
                        {...register('qtICTContracts', { onBlur: handleSubmit(submitActivitiesInnovationForm), valueAsNumber: true })}
                    />
                </Form.Item>
                <h4 className="mt-4">
                    <strong style={{ color: '#000085' }}>Pessoal Ocupado em Atividades de P&D</strong>
                </h4>
                <p className="mt-4 d-block w-75">Informe o número de pessoas do quadro da empresa ocupadas nas atividades de P&D no último ano, segundo o nível de qualificação e o tempo de dedicação e estas atividades:</p>
                <div className="d-flex mt-4 w-100">
                    <div className="w-100 me-4">
                        <Table
                            columns={qualificationColumns}
                            dataSource={qualificationData}
                            pagination={false}
                            bordered={false}
                            className="no-border-table"
                        />
                    </div>
                    <div className="w-100">
                        <Table
                            columns={dedicationColumns}
                            dataSource={dedicationData}
                            pagination={false}
                            bordered={false}
                            className="no-border-table"
                        />
                    </div>
                </div>
                <h4 className="mt-4">
                    <strong style={{ color: '#000085' }}>
                        Parcerias em Atividades Inovativas
                    </strong>
                </h4>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px' }}>
                    <div style={{ flex: '1 1 45%', minWidth: '300px' }}>
                        <p className="d-block me-4">Quantos contratos de parceria com ICTs para auxílio às atividades inovativas da empresa estavam vigentes no último ano?</p>
                        <Form.Item>
                            <Input
                                type="number"
                                style={{ width: '100%' }}
                                disabled={hasValidated}
                                {...register('qtICTContracts', { onBlur: handleSubmit(submitActivitiesInnovationForm), valueAsNumber: true })}
                            />
                        </Form.Item>
                    </div>
                    <div style={{ flex: '1 1 45%', minWidth: '300px' }}>
                        <p className="d-block me-4">Qual o valor total dos contratos de parceria com ICTs para auxílio às atividades inovativas da empresa que estavam vigentes, em R$, no último ano?</p>
                        <Form.Item>
                            <Input
                                prefix="R$"
                                style={{ width: '100%' }}
                                disabled={hasValidated}
                                {...register('totalValueOfICTContracts', { onBlur: handleSubmit(submitActivitiesInnovationForm) })}
                                value={getValues('totalValueOfICTContracts').toString().replace(".", ",")}
                            />
                        </Form.Item>
                    </div>
                    <div style={{ flex: '1 1 45%', minWidth: '300px' }}>
                        <p className="d-block me-4">Quantos contratos de parceria com empresas, para auxílio às atividades inovativas da sua empresa, estavam vigentes no último ano?</p>
                        <Form.Item>
                            <Input
                                type="number"
                                style={{ width: '100%' }}
                                disabled={hasValidated}
                                {...register('qtCompanyPartnerships', { onBlur: handleSubmit(submitActivitiesInnovationForm), valueAsNumber: true })}
                            />
                        </Form.Item>
                    </div>
                    <div style={{ flex: '1 1 45%', minWidth: '300px' }}>
                        <p className="d-block me-4">Qual o valor total dos contratos de parceria com empresas, para auxílio às atividades inovativas da sua empresa, que estavam vigentes em R$, no último ano?</p>
                        <Form.Item>
                            <Input
                                prefix="R$"
                                style={{ width: '100%' }}
                                disabled={hasValidated}
                                {...register('totalValueOfCompanyPartnerships', { onBlur: handleSubmit(submitActivitiesInnovationForm) })}
                                value={getValues('totalValueOfCompanyPartnerships').toString().replace(".", ",")}
                            />
                        </Form.Item>
                    </div>
                </div>
                <p className="d-block mt-3">Descreva as parcerias que a empresa estabeleceu nos últimos três anos no auxílio às suas atividades inovativas, Considere a relação com empresas, institutos,
                    laboratórios, universidades, agências públicas de fomento, etc.
                </p>
                <Form.Item>
                    <TextArea
                        disabled={hasValidated}
                        placeholder="Descreva aqui"
                        {...register('partnershipsDescription', { onBlur: handleSubmit(submitActivitiesInnovationForm) })}
                    />
                </Form.Item>
                <h4 className="mt-4">
                    <strong style={{ color: '#000085' }}>
                        Dispêndios em Atividades Inovativas
                    </strong>
                </h4>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px' }}>
                    <div style={{ flex: '1 1 45%', minWidth: '300px' }}>
                        <p style={{ marginBottom: '8px ' }}>Qual o valor dos dispêndios com P&D interno executados pela empresa, em R$, no último ano?</p>
                        <Form.Item>
                            <Input
                                prefix="R$"
                                style={{ width: '100%' }}
                                disabled={hasValidated}
                                {...register('internalRnDExpenditures', { onBlur: handleSubmit(submitActivitiesInnovationForm) })}
                                value={getValues('internalRnDExpenditures').toString().replace(".", ",")}
                            />
                        </Form.Item>

                    </div>
                    <div style={{ flex: '1 1 45%', minWidth: '300px' }}>
                        <p style={{ marginBottom: '8px ' }}>Qual o valor dos dispêndios com aquisição externa de P&D, em R$, no último ano?</p>
                        <Form.Item>
                            <Input
                                prefix="R$"
                                disabled={hasValidated}
                                {...register('externalRnDExpenditures', { onBlur: handleSubmit(submitActivitiesInnovationForm) })}
                                style={{ width: '100%' }}
                                value={getValues('externalRnDExpenditures').toString().replace(".", ",")}
                            />
                        </Form.Item>
                    </div>
                    <div style={{ flex: '1 1 45%', minWidth: '300px' }}>
                        <p style={{ marginBottom: '8px ' }}>Qual o valor dos dispêndios com máquinas e equipamentos para inovação, em R$, no último ano?</p>
                        <Form.Item>
                            <Input
                                prefix="R$"
                                style={{ width: '100%' }}
                                disabled={hasValidated}
                                {...register('machineryAndEquipmentExpenditures', { onBlur: handleSubmit(submitActivitiesInnovationForm) })}
                                value={getValues('machineryAndEquipmentExpenditures').toString().replace(".", ",")}
                            />
                        </Form.Item>

                    </div>
                    <div style={{ flex: '1 1 45%', minWidth: '300px' }}>
                        <p style={{ marginBottom: '8px ' }}>Qual o valor dos dispêndios totais com atividades inovativas executadas pela empresas em, em R$, no último ano?</p>
                        <Form.Item>
                            <Input
                                prefix="R$"
                                style={{ width: '100%' }}
                                disabled={hasValidated}
                                {...register('totalInnovativeActivityExpenditures', { onBlur: handleSubmit(submitActivitiesInnovationForm) })}
                                value={getValues('totalInnovativeActivityExpenditures').toString().replace(".", ",")}
                            />
                        </Form.Item>
                    </div>
                </div>
                <p className="d-block mt-3">Nos últimos três anos, a empresa utilizou algum dos programas de apoio do governo, relacionados a seguir, para suas atividades inovativas?</p>
                <Form.Item className="w-75 mt-2">
                    <Select
                        mode="multiple"
                        disabled={hasValidated}
                        value={governmentSupport}
                        onChange={handleChange}
                        onBlur={() => submitActivitiesInnovationForm(getValues())}
                        tagRender={({ label, value, closable, onClose }) => {
                            const onPreventMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
                                event.preventDefault();
                                event.stopPropagation();
                            };
                            return (
                                <Tag
                                    onMouseDown={onPreventMouseDown}
                                    closable={closable}
                                    onClose={onClose}
                                    style={{ marginRight: 3 }}
                                >
                                    {governmentSupportEnum.find(x => x.value == value)?.name ?? ""}
                                </Tag>
                            );
                        }}
                    >
                        {governmentSupportEnum.map((item, index) => {
                            return (
                                <Option key={item.value} value={item.value}>{item.name}</Option>
                            )
                        })}
                    </Select>
                </Form.Item>
                {governmentSupport.includes("others") &&
                    <Form.Item className="mt-2" style={{ width: '100%' }}>
                        <Input
                            placeholder="Especifique o outros"
                            disabled={hasValidated}
                            {...register('others', { onBlur: handleSubmit(submitActivitiesInnovationForm) })}
                        />
                    </Form.Item>
                }
            </div>
        </form>
    );
};



// import { useContext, useEffect, useState } from "react";
// import { UseFormReturn } from "react-hook-form";
// import { Typography } from "antd";
// import { CurrencyInput } from "../../../../Components/Shared/CurrencyInput";
// import { InnovationActivityFinepModel } from "../../../../Models/InnovationActivityFINEPModel";
// import { TextField, MenuItem, Select, FormControl, InputLabel, OutlinedInput, Stack, Chip, SelectChangeEvent } from "@mui/material";
// import TabsHeader from "../../../../Components/Shared/TabsHeader";
// import Loader from "../../../../Components/Shared/Loader";
// import useLoading from "../../../../Hooks/useLoading";
// import { governmentSupportEnum } from "../../../../Static/GovernmentSupportEnum";
// import { PostInnovationActivityFinepAPI, PutInnovationActivityFinepAPI } from "../../../../API/InnovationActivityFinepAPI";
// import { IResponseProps } from "../../../../Interfaces/IResponseProps";
// import { toast } from "react-toastify";
// import { convertCurrencyToFloat } from "../../../../Utils/convertCurrencyToFloat";
// import { TechnologicalFeaturesFinepContext } from "../../../../Contexts/TechnologicalFeaturesFinepContext";

// const { Title, Text } = Typography;

// interface ActivitiesInnovationTabProps {
//     innovationActivityForm: UseFormReturn<InnovationActivityFinepModel, any>,
//     getFilledFourthTabCount: (dataResp: InnovationActivityFinepModel) => number,
//     calculatePercentage: (isValidated: boolean, tabName: string, qtdFilled: number) => void,
//     setCanValidateFourthTab: React.Dispatch<React.SetStateAction<boolean>>,
//     canValidateFourthTab: boolean
// }

// export const ActivitiesInnovationTab = (props: ActivitiesInnovationTabProps) => {
//     const { watch, register, handleSubmit, setValue, getValues, formState } = props.innovationActivityForm;
//     const { isDirty, dirtyFields } = formState;
//     const { loading, toggleLoading } = useLoading();
//     const [hasValidated, setHasValidated] = useState<boolean>(false);
//     const [governmentSupport, setGovernmentSupport] = useState<string[]>([]);
//     const innovationActivityFields = 15;

//     const watchIsValid = watch("isValid");
//     const watchGovernment = watch('governmentSupportPrograms');
//     const { handleFillTab } = useContext(TechnologicalFeaturesFinepContext);

//     const PostInnovationActivityFinep = async (data: InnovationActivityFinepModel) => {
//         try {
//             toggleLoading(true);

//             await PostInnovationActivityFinepAPI(data).then((resp: IResponseProps) => {
//                 if (resp.statusCode == 200) {
//                     var dataResp = resp.data;

//                     var filled = props.getFilledFourthTabCount(dataResp);

//                     if (filled == innovationActivityFields) {
//                         props.setCanValidateFourthTab(true);
//                     } else {
//                         props.setCanValidateFourthTab(false);
//                     }

//                     setValue('id', dataResp.id);
//                     handleFillTab(3);
//                     props.calculatePercentage(data.isValid, 'innovationActivity', filled);
//                 }
//             });
//         } catch (error: any) {
//             toast.error(error);
//         } finally {
//             toggleLoading(false);
//         }
//     }

//     const PutInnovationActivityFinep = async (data: InnovationActivityFinepModel) => {
//         try {
//             toggleLoading(true);

//             await PutInnovationActivityFinepAPI(data).then((resp: IResponseProps) => {
//                 if (resp.statusCode == 200) {
//                     var dataResp = resp.data;

//                     var filled = props.getFilledFourthTabCount(dataResp);

//                     if (filled == innovationActivityFields) {
//                         props.setCanValidateFourthTab(true);
//                     } else {
//                         props.setCanValidateFourthTab(false);
//                     }

//                     handleFillTab(3);
//                     props.calculatePercentage(data.isValid, 'innovationActivity', filled);
//                 }
//             });
//         } catch (error: any) {
//             toast.error(error);
//         } finally {
//             toggleLoading(false);
//         }
//     }

//     const EditFields = (data: InnovationActivityFinepModel) => {
//         if (dirtyFields.totalValueOfICTContracts) {
//             let value = 0;
//             if (data.totalValueOfICTContracts.toString().includes("R$")) {
//                 value = convertCurrencyToFloat(data.totalValueOfICTContracts.toString());
//             } else {
//                 value = parseFloat(data.totalValueOfICTContracts.toString())
//             }
//             data.totalValueOfICTContracts = value;
//             setValue('totalValueOfICTContracts', value);
//         }
//         if (dirtyFields.totalValueOfCompanyPartnerships) {
//             let value = 0;
//             if (data.totalValueOfCompanyPartnerships.toString().includes("R$")) {
//                 value = convertCurrencyToFloat(data.totalValueOfCompanyPartnerships.toString());
//             } else {
//                 value = parseFloat(data.totalValueOfCompanyPartnerships.toString())
//             }
//             data.totalValueOfCompanyPartnerships = value;
//             setValue('totalValueOfCompanyPartnerships', value);
//         }
//         if (dirtyFields.internalRnDExpenditures) {
//             let value = 0;
//             if (data.internalRnDExpenditures.toString().includes("R$")) {
//                 value = convertCurrencyToFloat(data.internalRnDExpenditures.toString());
//             } else {
//                 value = parseFloat(data.internalRnDExpenditures.toString())
//             }
//             data.internalRnDExpenditures = value;
//             setValue('internalRnDExpenditures', value);
//         }
//         if (dirtyFields.externalRnDExpenditures) {
//             let value = 0;
//             if (data.externalRnDExpenditures.toString().includes("R$")) {
//                 value = convertCurrencyToFloat(data.externalRnDExpenditures.toString());
//             } else {
//                 value = parseFloat(data.externalRnDExpenditures.toString());
//             }
//             data.externalRnDExpenditures = value;
//             setValue('externalRnDExpenditures', value);
//         }
//         if (dirtyFields.machineryAndEquipmentExpenditures) {
//             let value = 0;
//             if (data.machineryAndEquipmentExpenditures.toString().includes("R$")) {
//                 value = convertCurrencyToFloat(data.machineryAndEquipmentExpenditures.toString());
//             } else {
//                 value = parseFloat(data.machineryAndEquipmentExpenditures.toString());
//             }
//             data.machineryAndEquipmentExpenditures = value;
//             setValue('machineryAndEquipmentExpenditures', value);
//         }
//         if (dirtyFields.totalInnovativeActivityExpenditures) {
//             let value = 0;
//             if (data.totalInnovativeActivityExpenditures.toString().includes("R$")) {
//                 value = convertCurrencyToFloat(data.totalInnovativeActivityExpenditures.toString());
//             } else {
//                 value = parseFloat(data.totalInnovativeActivityExpenditures.toString())
//             }
//             data.totalInnovativeActivityExpenditures = value;
//             setValue('totalInnovativeActivityExpenditures', value);
//         }

//         let value1 = JSON.parse(data.hasDepToPndLocal.toString());
//         data.hasDepToPndLocal = value1;
//         setValue('hasDepToPndLocal', value1.toString());

//         let value2 = JSON.parse(data.hasDepToPndGlobal.toString());
//         data.hasDepToPndGlobal = value2;
//         setValue('hasDepToPndGlobal', value2.toString());

//         return data;
//     }

//     const submitActivitiesInnovationForm = (data: InnovationActivityFinepModel) => {
//         if (isDirty || hasValidated != data.isValid) {
//             data.governmentSupportPrograms = governmentSupport.join(",");

//             if (data.pndActivityLastYears?.toString() == "") {
//                 data.pndActivityLastYears = undefined;
//             }

//             var newData = EditFields(data);

//             if (data.governmentSupportPrograms.includes("others") && data.others == "") {
//                 return;
//             }

//             if ((data.hasDepToPndLocal == true && data.activityPndLocal == "") || (data.hasDepToPndGlobal == true && data.activityPndGlobal == "")) {
//                 return;
//             }

//             newData.isValid = hasValidated;
//             setValue('isValid', hasValidated);

//             if (newData.id != "") {
//                 PutInnovationActivityFinep(newData);
//             } else {
//                 PostInnovationActivityFinep(newData);
//             }
//         }
//     };

//     const handleChange = (event: SelectChangeEvent<typeof governmentSupport>) => {
//         const {
//             target: { value },
//         } = event;
//         setGovernmentSupport(
//             // On autofill we get a stringified value.
//             typeof value === 'string' ? value.split(',') : value,
//         );
//     };

//     const updateGovernment = () => {
//         setGovernmentSupport(getValues("governmentSupportPrograms") != "" ? getValues("governmentSupportPrograms").split(",") : []);
//     }

//     const updateHasValidated = () => {
//         setHasValidated(props.canValidateFourthTab == true ? JSON.parse(getValues("isValid").toString()) : false);
//     }

//     useEffect(() => {
//         updateGovernment();
//     }, [watchGovernment]);

//     useEffect(() => {
//         if (hasValidated.toString() != getValues("isValid").toString()) {
//             submitActivitiesInnovationForm(getValues());
//         }
//     }, [hasValidated]);

//     useEffect(() => {
//         updateHasValidated();
//     }, [watchIsValid, props.canValidateFourthTab]);

//     return (
//         <form onSubmit={handleSubmit(submitActivitiesInnovationForm)}>
//             {loading && <Loader />}

//             <div className="p-4">
//                 <TabsHeader
//                     canValidate={props.canValidateFourthTab}
//                     setValueSelected={setHasValidated}
//                     valueSelected={hasValidated}
//                     registerId={getValues("registerId")}
//                     cardName=""
//                     tabName=""
//                 />
//                 <Title level={4} >
//                     <strong className="color-blue">Infraestrutura P&D</strong>
//                 </Title>

//                 <div className="mt-4 d-flex align-items-center">
//                     <strong>As atividades de P&D realizadas nos últimos 3 anos foram:</strong>
//                     <FormControl className="">
//                         <InputLabel id="label-select-pd">Selecione</InputLabel>
//                         <Select
//                             className="w-100"
//                             label="Selecione"
//                             disabled={hasValidated}
//                             labelId="label-select-pd"
//                             value={getValues('pndActivityLastYears')?.toString() ?? ""}
//                             {...register('pndActivityLastYears', { onBlur: handleSubmit(submitActivitiesInnovationForm) })}
//                         >
//                             <MenuItem value="0">Inexistentes</MenuItem>
//                             <MenuItem value="1">Ocasionais</MenuItem>
//                             <MenuItem value="2">Contínuas</MenuItem>
//                         </Select>
//                     </FormControl>
//                 </div>
//                 <div className="mt-4 d-flex align-items-center ">
//                     <strong>A empresa possui departamento, ou unidade formal, para execução das atividades internas de P&D no Brasil?</strong>
//                     <FormControl className="ms-2">
//                         <InputLabel id="label-select-department">Selecione</InputLabel>
//                         <Select
//                             className="w-25"
//                             label="Selecione"
//                             disabled={hasValidated}
//                             labelId="label-select-department"
//                             {...register('hasDepToPndLocal', { onBlur: handleSubmit(submitActivitiesInnovationForm) })}
//                             value={getValues('hasDepToPndLocal')?.toString()}
//                         >
//                             <MenuItem value="true">Sim</MenuItem>
//                             <MenuItem value="false">Não</MenuItem>
//                         </Select>
//                     </FormControl>
//                 </div>
//                 {getValues('hasDepToPndLocal')?.toString() == "true" &&
//                     <TextField
//                         label="Indique a localização do(s) departamento9s), ou da(s) unidade(s) formal(is), onde se concentram as atividades de P&D da empresa:"
//                         className="w-75 mt-4"
//                         type="text"
//                         disabled={hasValidated}
//                         {...register('activityPndLocal', { onBlur: handleSubmit(submitActivitiesInnovationForm) })}
//                     />
//                 }
//                 <div className="mt-4 d-flex align-items-center ">
//                     <strong>A empresa possui departamento, ou unidade formal, para execução das atividades internas de P&D localizado no exterior?</strong>
//                     <FormControl className="ms-2">
//                         <InputLabel id="label-select-extern">Selecione</InputLabel>
//                         <Select
//                             className="w-25"
//                             label="Selecione"
//                             disabled={hasValidated}
//                             labelId="label-select-extern"
//                             {...register('hasDepToPndGlobal', { onBlur: handleSubmit(submitActivitiesInnovationForm) })}
//                             value={getValues('hasDepToPndGlobal')?.toString()}
//                         >
//                             <MenuItem value="true">Sim</MenuItem>
//                             <MenuItem value="false">Não</MenuItem>
//                         </Select>
//                     </FormControl>
//                 </div>
//                 {getValues('hasDepToPndGlobal')?.toString() == "true" &&
//                     <TextField
//                         label="Descreva a infraestrutura própria utilizada para as atividades inovativas"
//                         className="mt-4 w-75"
//                         disabled={hasValidated}
//                         {...register('activityPndGlobal', { onBlur: handleSubmit(submitActivitiesInnovationForm) })}
//                     />
//                 }

//                 <h4 className="mt-4">
//                     <strong>Pessoal Ocupado em Atividades de P&D</strong>
//                 </h4>
//                 <p className="mt-4 d-block w-75">Informe o número de pessoas do quadro da empresa ocupadas nas atividades de P&D no último ano, segundo o nível de qualificação e o tempo de dedicação e estas atividades:</p>
//                 <div className="d-flex mt-4 w-100">
//                     <div className="w-100 me-4">
//                         <table className="table-activities">
//                             <thead>
//                                 <tr>
//                                     <th className="color-blue">Nível de Qualificação</th>
//                                     <th className="color-blue">Total de Pessoas</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 <tr>
//                                     <td>Pesquisadores - Doutores</td>
//                                     <td>
//                                         <TextField
//                                             className="h-100"
//                                             size="small"
//                                             disabled={hasValidated}
//                                             type="number"
//                                             {...register('qtResearchersDoctors', { onBlur: handleSubmit(submitActivitiesInnovationForm), valueAsNumber: true })}
//                                         />
//                                     </td>
//                                 </tr>
//                                 <tr>
//                                     <td>Pesquisadores - Mestres</td>
//                                     <td>
//                                         <TextField
//                                             className="h-100"
//                                             size="small"
//                                             disabled={hasValidated}
//                                             type="number"
//                                             {...register('qtResearchersMasters', { onBlur: handleSubmit(submitActivitiesInnovationForm), valueAsNumber: true })}
//                                         />
//                                     </td>
//                                 </tr>
//                                 <tr>
//                                     <td>Pesquisadores - Graduados</td>
//                                     <td>
//                                         <TextField
//                                             className="h-100"
//                                             size="small"
//                                             disabled={hasValidated}
//                                             type="number"
//                                             {...register('qtResearchersGraduates', { onBlur: handleSubmit(submitActivitiesInnovationForm), valueAsNumber: true })}
//                                         />
//                                     </td>
//                                 </tr>
//                                 <tr>
//                                     <td>Pesquisadores - Médio e Fundamental</td>
//                                     <td>
//                                         <TextField
//                                             className="h-100"
//                                             size="small"
//                                             disabled={hasValidated}
//                                             type="number"
//                                             {...register('qtResearchersBasic', { onBlur: handleSubmit(submitActivitiesInnovationForm), valueAsNumber: true })}
//                                         />
//                                     </td>
//                                 </tr>
//                                 <tr>
//                                     <td>Técnicos - Graduados</td>
//                                     <td>
//                                         <TextField
//                                             className="h-100"
//                                             size="small"
//                                             type="number"
//                                             disabled={hasValidated}
//                                             {...register('qtTechniciansGraduates', { onBlur: handleSubmit(submitActivitiesInnovationForm), valueAsNumber: true })}
//                                         />
//                                     </td>
//                                 </tr>
//                                 <tr>
//                                     <td>Técnicos - Médio e Fundamental</td>
//                                     <td>
//                                         <TextField
//                                             className="h-100"
//                                             size="small"
//                                             disabled={hasValidated}
//                                             type="number"
//                                             {...register('qtTechniciansBasic', { onBlur: handleSubmit(submitActivitiesInnovationForm), valueAsNumber: true })}
//                                         />
//                                     </td>
//                                 </tr>
//                                 <tr>
//                                     <td>Auxiliares - Outros</td>
//                                     <td>
//                                         <TextField
//                                             className="h-100"
//                                             size="small"
//                                             disabled={hasValidated}
//                                             type="number"
//                                             {...register('qtAssistantOther', { onBlur: handleSubmit(submitActivitiesInnovationForm), valueAsNumber: true })}
//                                         />
//                                     </td>
//                                 </tr>
//                             </tbody>
//                         </table>
//                     </div>

//                     <div className="w-100">
//                         <table className="table-activities">
//                             <thead>
//                                 <tr>
//                                     <th className="color-blue">Nível de Dedicação às atividades de P&D</th>
//                                     <th className="color-blue">Total de Pessoas</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 <tr>
//                                     <td>Dedicação Exclusiva</td>
//                                     <td>
//                                         <TextField
//                                             className="h-100"
//                                             size="small"
//                                             disabled={hasValidated}
//                                             type="number"
//                                             {...register('qtDedicationExclusive', { onBlur: handleSubmit(submitActivitiesInnovationForm), valueAsNumber: true })}
//                                         />
//                                     </td>
//                                 </tr>
//                                 <tr>
//                                     <td>Dedicação Parcial</td>
//                                     <td>
//                                         <TextField
//                                             className="h-100"
//                                             size="small"
//                                             disabled={hasValidated}
//                                             type="number"
//                                             {...register('qtDedicationPartial', { onBlur: handleSubmit(submitActivitiesInnovationForm), valueAsNumber: true })}
//                                         />
//                                     </td>
//                                 </tr>
//                             </tbody>
//                         </table>
//                     </div>

//                 </div>
//                 <h4 className="mt-4">
//                     <strong>
//                         Parcerias em Atividades Inovativas
//                     </strong>
//                 </h4>
//                 <div className="d-flex align-items-center justify-content-between mt-4">
//                     <p className="d-block me-4">Quantos contratos de parceria com ICTs para auxílio às atividades inovativas da empresa estavam vigentes no último ano?</p>
//                     <TextField
//                         type="number"
//                         className="w-25"
//                         disabled={hasValidated}
//                         {...register('qtICTContracts', { onBlur: handleSubmit(submitActivitiesInnovationForm), valueAsNumber: true })}
//                     />
//                 </div>
//                 <div className="d-flex align-items-center justify-content-between mt-3">
//                     <p className="d-block me-4">Qual o valor total dos contratos de parceria com ICTs para auxílio às atividades inovativas da empresa que estavam vigentes, em R$, no último ano?</p>
//                     <TextField
//                         label="R$"
//                         className='w-25'
//                         disabled={hasValidated}
//                         {...register('totalValueOfICTContracts', { onBlur: handleSubmit(submitActivitiesInnovationForm) })}
//                         value={getValues('totalValueOfICTContracts').toString().replace(".", ",")}
//                         InputProps={{
//                             inputComponent: CurrencyInput as any,
//                         }}
//                         variant="outlined"
//                     />
//                 </div>
//                 <div className="d-flex align-items-center justify-content-between mt-3">
//                     <p className="d-block me-4">Quantos contratos de parceria com empresas, para auxílio às atividades inovativas da sua empresa, estavam vigentes no último ano?</p>
//                     <TextField
//                         type="number"
//                         className="w-25"
//                         disabled={hasValidated}
//                         {...register('qtCompanyPartnerships', { onBlur: handleSubmit(submitActivitiesInnovationForm), valueAsNumber: true })}
//                     />
//                 </div>
//                 <div className="d-flex align-items-center justify-content-between mt-3">
//                     <p className="d-block me-4">Qual o valor total dos contratos de parceria com empresas, para auxílio às atividades inovativas da sua empresa, que estavam vigentes em R$, no último ano?</p>
//                     <TextField
//                         label="R$"
//                         className='w-25'
//                         disabled={hasValidated}
//                         {...register('totalValueOfCompanyPartnerships', { onBlur: handleSubmit(submitActivitiesInnovationForm) })}
//                         value={getValues('totalValueOfCompanyPartnerships').toString().replace(".", ",")}
//                         InputProps={{
//                             inputComponent: CurrencyInput as any,
//                         }}
//                         variant="outlined"
//                     />
//                 </div>
//                 <strong className="d-block mt-3">Descreva as parcerias que a empresa estabeleceu nos últimos três anos no auxílio às suas atividades inovativas, Considere a relação com empresas, institutos,
//                     laboratórios, universidades, agências públicas de fomento, etc.
//                 </strong>
//                 <TextField
//                     className="mt-2 w-100"
//                     disabled={hasValidated}
//                     placeholder="Descreva aqui"
//                     {...register('partnershipsDescription', { onBlur: handleSubmit(submitActivitiesInnovationForm) })}
//                 />
//                 <h4 className="mt-4">
//                     <strong>
//                         Dispêndios em Atividades Inovativas
//                     </strong>
//                 </h4>
//                 <div className="d-flex align-items-center justify-content-between mt-4">
//                     <p className="d-block me-4">Qual o valor dos dispêndios com P&D interno executados pela empresa, em R$, no último ano?</p>
//                     <TextField
//                         label="R$"
//                         className='w-25'
//                         disabled={hasValidated}
//                         {...register('internalRnDExpenditures', { onBlur: handleSubmit(submitActivitiesInnovationForm) })}
//                         value={getValues('internalRnDExpenditures').toString().replace(".", ",")}
//                         InputProps={{
//                             inputComponent: CurrencyInput as any,
//                         }}
//                         variant="outlined"
//                     />
//                 </div>
//                 <div className="d-flex align-items-center justify-content-between mt-3">
//                     <p className="d-block me-4">Qual o valor dos dispêndios com aquisição externa de P&D, em R$, no último ano?</p>
//                     <TextField
//                         label="R$"
//                         disabled={hasValidated}
//                         {...register('externalRnDExpenditures', { onBlur: handleSubmit(submitActivitiesInnovationForm) })}
//                         className='w-25'
//                         value={getValues('externalRnDExpenditures').toString().replace(".", ",")}
//                         InputProps={{
//                             inputComponent: CurrencyInput as any,
//                         }}
//                         variant="outlined"
//                     />
//                 </div>
//                 <div className="d-flex align-items-center justify-content-between mt-3">
//                     <p className="d-block me-4">Qual o valor dos dispêndios com máquinas e equipamentos para inovação, em R$, no último ano?</p>
//                     <TextField
//                         label="R$"
//                         className='w-25'
//                         disabled={hasValidated}
//                         {...register('machineryAndEquipmentExpenditures', { onBlur: handleSubmit(submitActivitiesInnovationForm) })}
//                         value={getValues('machineryAndEquipmentExpenditures').toString().replace(".", ",")}
//                         InputProps={{
//                             inputComponent: CurrencyInput as any,
//                         }}
//                         variant="outlined"
//                     />
//                 </div>
//                 <div className="d-flex align-items-center justify-content-between mt-3">
//                     <p className="d-block me-4">Qual o valor dos dispêndios totais com atividades inovativas executadas pela empresas em, em R$, no último ano?</p>
//                     <TextField
//                         label="R$"
//                         className='w-25'
//                         disabled={hasValidated}
//                         {...register('totalInnovativeActivityExpenditures', { onBlur: handleSubmit(submitActivitiesInnovationForm) })}
//                         value={getValues('totalInnovativeActivityExpenditures').toString().replace(".", ",")}
//                         InputProps={{
//                             inputComponent: CurrencyInput as any,
//                         }}
//                         variant="outlined"
//                     />
//                 </div>
//                 <strong className="d-block mt-3">Nos últimos três anos, a empresa utilizou algum dos programas de apoio do governo, relacionados a seguir, para suas atividades inovativas?</strong>
//                 <FormControl className="w-100 mt-2">
//                     <InputLabel id="label-select-extern">Selecione</InputLabel>
//                     <Select
//                         className="w-75"
//                         label="Selecione"
//                         disabled={hasValidated}
//                         labelId="label-select-extern"
//                         multiple
//                         value={governmentSupport}
//                         onChange={handleChange}
//                         onBlur={() => submitActivitiesInnovationForm(getValues())}
//                         input={<OutlinedInput label="Multiple Select" />}
//                         renderValue={(selected) => (
//                             <Stack gap={1} direction="row" flexWrap="wrap">
//                                 {selected.map((value) => (
//                                     <Chip key={value} label={governmentSupportEnum.find(x => x.value == value)?.name ?? ""} />
//                                 ))}
//                             </Stack>
//                         )}
//                     >
//                         {governmentSupportEnum.map((item, index) => {
//                             return (
//                                 <MenuItem value={item.value}>{item.name}</MenuItem>
//                             )
//                         })}
//                     </Select>
//                 </FormControl>
//                 {governmentSupport.includes("others") &&
//                     <TextField
//                         label="Especifique o outros"
//                         className="mt-2 w-75"
//                         disabled={hasValidated}
//                         {...register('others', { onBlur: handleSubmit(submitActivitiesInnovationForm) })}
//                     />
//                 }
//             </div>
//         </form>
//     );
// };